import React, { useState } from "react";
import { FaLinkedin, FaInstagram, FaFacebook } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import blogsJson from "../data/blogs.json";
import BlogCard from "../componets/BlogCard";

export default function AuthorProfile({
  image,
  name,
  role,
  about,
  stats,
  social,
}) {
  // filter only blogs for this author
  const authorBlogs = blogsJson.filter((blog) =>
    name.toLowerCase().includes(blog.author?.toLowerCase()),
  );

  const contributions = {
    Tutorials: [], // can add later if needed
    "Blog posts": authorBlogs,
  };

  const [activeTab, setActiveTab] = useState("Tutorials");

  return (
    <div className="w-full max-w-6xl mx-auto p-4 py-20 md:py-40">
      <div className="flex flex-col md:flex-row gap-8 md:gap-10">
        {/* Left Side: Author Info */}
        <div className="flex flex-col items-center md:items-start w-full md:w-1/4 text-center md:text-left mt-32 md:mt-0">
          <img
            src={image}
            alt={name}
            className="w-48 h-48 sm:w-56 sm:h-56 md:w-60 md:h-60 rounded-xl object-cover"
          />
          <h2 className="mt-4 text-xl sm:text-2xl font-bold text-gray-900">
            {name}
          </h2>
          <p className="text-gray-600 font-semibold mt-1">{role}</p>
          {about && (
            <p className="text-gray-600 mt-4 text-sm sm:text-base md:text-base">
              {about}
            </p>
          )}

          {/* Social Icons */}
          {social && (
            <div className="flex gap-4 mt-4 text-2xl text-gray-600">
              {social.linkedin && (
                <a
                  href={social.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-blue-700"
                >
                  <FaLinkedin />
                </a>
              )}

              {social.instagram && (
                <a
                  href={social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-pink-500"
                >
                  <FaInstagram />
                </a>
              )}

              {social.facebook && (
                <a
                  href={social.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-blue-600"
                >
                  <FaFacebook />
                </a>
              )}

              {(social.x || social.twitter) && (
                <a
                  href={social.x || social.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-black"
                >
                  <FaXTwitter />
                </a>
              )}
            </div>
          )}
        </div>

        {/* Right Side: Stats & Contributions */}
        <div className="flex-1">
          {/* Stats */}
          <div className="bg-gray-50 rounded-xl p-4 sm:p-6 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 border border-gray-200">
            {stats.map((item, idx) => (
              <div key={idx}>
                <p className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900">
                  {item.value}
                </p>
                <p className="text-sm sm:text-base text-gray-600">
                  {item.label}
                </p>
              </div>
            ))}
          </div>

          {/* Contributions */}
          <div className="bg-gray-50 rounded-xl border border-gray-200 p-4 sm:p-6 mt-6 md:mt-8">
            <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3">
              Community Contributions
            </h3>

            {/* Tabs */}
            <div className="flex flex-wrap gap-2 mb-4">
              {Object.keys(contributions).map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`px-3 sm:px-4 py-1 sm:py-2 rounded-full text-[14px] sm:text-[16px] font-medium ${
                    activeTab === tab
                      ? "bg-gray-200 text-gray-900"
                      : "text-gray-600 hover:bg-gray-100"
                  }`}
                >
                  {tab} ({contributions[tab].length})
                </button>
              ))}
            </div>

            {/* Content */}
            <div>
              {contributions[activeTab].length > 0 ? (
                activeTab === "Blog posts" ? (
                  <div className="flex flex-col sm:flex-row sm:flex-wrap gap-6 sm:gap-28 overflow-x-hidden">
                    {contributions[activeTab].map((blog, i) => (
                      <BlogCard key={blog.handle + i} blog={blog} />
                    ))}
                  </div>
                ) : (
                  <p className="text-gray-500 italic">
                    No {activeTab.toLowerCase()} available yet.
                  </p>
                )
              ) : (
                <p className="text-gray-500 italic">
                  No {activeTab.toLowerCase()} available yet.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
